import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { ConnectionCheckService } from '../services/connection-check.service';

export const siteUpGuard: CanDeactivateFn<unknown> = (
  _component: unknown,
  _currentRoute: ActivatedRouteSnapshot,
  _currentState: RouterStateSnapshot,
  _nextState: RouterStateSnapshot
): MaybeAsync<GuardResult> => {
  const connectionCheckService = inject(ConnectionCheckService);

  return connectionCheckService.hasServerConnection();
};
